const validXmlCharPattern =
  // biome-ignore lint/suspicious/noControlCharactersInRegex: While it is not pretty, it is acceptable.
  /^[\u0009\u000A\u000D\u0020-\uD7FF\uE000-\uFFFD\u10000-\u10FFFF]*$/;

export function isValidXmlCharacters(value: string | undefined) {
  return !value || validXmlCharPattern.test(value);
}
